// Generated by purs version 0.15.0
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Monoid_Extra from "../Data.Monoid.Extra/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_Accounts_Types_Id from "../Restaumatic.Accounts.Types.Id/index.js";
import * as Restaumatic_Countries from "../Restaumatic.Countries/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_Site_Translations_Keys from "../Restaumatic.Site.Translations.Keys/index.js";
var House = /* #__PURE__ */ (function () {
    function House() {

    };
    House.value = new House();
    return House;
})();
var Block = /* #__PURE__ */ (function () {
    function Block() {

    };
    Block.value = new Block();
    return Block;
})();
var AddressExtra = function (x) {
    return x;
};
var DeliveryAddress = function (x) {
    return x;
};
var LocatedDeliveryAddress = function (x) {
    return x;
};
var newtypeLocatedDeliveryAddress = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeDeliveryAddress = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeAddressExtra = {
    Coercible0: function () {
        return undefined;
    }
};
var isPostCodeRequired = function (accountId) {
    return function (country) {
        return Data_Foldable.elem(Data_Foldable.foldableArray)(Restaumatic_Countries.eqCountry)(country)([ Restaumatic_Countries.GB.value, Restaumatic_Countries.DE.value ]) || Data_Eq.eq(Restaumatic_Accounts_Types_Id.eqAccountId)(accountId)(31741);
    };
};
var genericHouseOrBlock = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return House.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return Block.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Address (line 77, column 1 - line 77, column 62): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof House) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Block) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Restaumatic.Address (line 77, column 1 - line 77, column 62): " + [ x.constructor.name ]);
    }
};
var showHouseOrBlock = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericHouseOrBlock)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "House";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Block";
        }
    })))
};
var showAddressExtra = /* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "additionalInfo";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "aptNumber";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "block";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "floor";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "houseOrBlock";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "interphone";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "sector";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "staircase";
    }
})(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showString))(Data_Show.showString))(showHouseOrBlock))(Data_Show.showString))(Data_Show.showString))(Data_Show.showString))(Data_Show.showString));
var showDeliveryAddress = /* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "aptNumber";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "city";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "country";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "extra";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "floor";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "formattedAddress";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "postCode";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "street";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "streetNumber";
    }
})(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showString))(Data_Show.showString))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(Data_Show.showString))(/* #__PURE__ */ Data_Maybe.showMaybe(showAddressExtra)))(Restaumatic_Countries.showCountry))(Data_Show.showString))(Data_Show.showString));
var showLocatedDeliveryAddress = /* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "address";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "location";
    }
})(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "latitude";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "longitude";
    }
})(Data_Show.showRecordFieldsNil)(Data_Show.showNumber))(Data_Show.showNumber))))(showDeliveryAddress));
var genericAddressExtra = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var eqHouseOrBlock = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericHouseOrBlock)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments)))
};
var eqAddressExtra = /* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
    reflectSymbol: function () {
        return "staircase";
    }
})(Data_Eq.eqString))()({
    reflectSymbol: function () {
        return "sector";
    }
})(Data_Eq.eqString))()({
    reflectSymbol: function () {
        return "interphone";
    }
})(Data_Eq.eqString))()({
    reflectSymbol: function () {
        return "houseOrBlock";
    }
})(eqHouseOrBlock))()({
    reflectSymbol: function () {
        return "floor";
    }
})(Data_Eq.eqString))()({
    reflectSymbol: function () {
        return "block";
    }
})(Data_Eq.eqString))()({
    reflectSymbol: function () {
        return "aptNumber";
    }
})(Data_Eq.eqString))()({
    reflectSymbol: function () {
        return "additionalInfo";
    }
})(Data_Eq.eqString));
var eqDeliveryAddress = /* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
    reflectSymbol: function () {
        return "streetNumber";
    }
})(Data_Eq.eqString))()({
    reflectSymbol: function () {
        return "street";
    }
})(Data_Eq.eqString))()({
    reflectSymbol: function () {
        return "postCode";
    }
})(Data_Eq.eqString))()({
    reflectSymbol: function () {
        return "formattedAddress";
    }
})(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString)))()({
    reflectSymbol: function () {
        return "floor";
    }
})(Data_Eq.eqString))()({
    reflectSymbol: function () {
        return "extra";
    }
})(/* #__PURE__ */ Data_Maybe.eqMaybe(eqAddressExtra)))()({
    reflectSymbol: function () {
        return "country";
    }
})(Restaumatic_Countries.eqCountry))()({
    reflectSymbol: function () {
        return "city";
    }
})(Data_Eq.eqString))()({
    reflectSymbol: function () {
        return "aptNumber";
    }
})(Data_Eq.eqString));
var eqLocatedDeliveryAddress = /* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
    reflectSymbol: function () {
        return "location";
    }
})(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
    reflectSymbol: function () {
        return "longitude";
    }
})(Data_Eq.eqNumber))()({
    reflectSymbol: function () {
        return "latitude";
    }
})(Data_Eq.eqNumber))))()({
    reflectSymbol: function () {
        return "address";
    }
})(eqDeliveryAddress));
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodeForeignHouseOrBlock = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericHouseOrBlock)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "House";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Block";
        }
    })))
};
var encodeForeignAddressExtra = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericAddressExtra)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "AddressExtra";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "staircase";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "sector";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "interphone";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "houseOrBlock";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeForeignHouseOrBlock)))({
        reflectSymbol: function () {
            return "floor";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "block";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "aptNumber";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "additionalInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(encodingOpts)
};
var emptyAddressExtra = /* #__PURE__ */ (function () {
    return {
        sector: "",
        houseOrBlock: House.value,
        block: "",
        staircase: "",
        floor: "",
        aptNumber: "",
        interphone: "",
        additionalInfo: ""
    };
})();
var displayHouseOrBlock = function (v) {
    if (v instanceof House) {
        return Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.formtastic.labels.delivery_address.house);
    };
    if (v instanceof Block) {
        return Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.formtastic.labels.delivery_address.block);
    };
    throw new Error("Failed pattern match at Restaumatic.Address (line 92, column 3 - line 94, column 67): " + [ v.constructor.name ]);
};
var defaultFormatBuildingAddress = function (v) {
    return v.street + (" " + (v.streetNumber + (", " + Data_String_Common.joinWith(" ")([ v.postCode, v.city ]))));
};
var formatAddressForDisplay = defaultFormatBuildingAddress;
var formatRomanianAddress = function (address) {
    var withPrefix = function (prefix) {
        return function (value) {
            return Data_Monoid_Extra.mwhen(Data_Monoid.monoidArray)(value !== "")([ prefix + (" " + value) ]);
        };
    };
    var extra = Data_Newtype.unwrap()(Data_Maybe.fromMaybe(emptyAddressExtra)((Data_Newtype.unwrap()(address)).extra));
    return Data_String_Common.joinWith(", ")(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ defaultFormatBuildingAddress(address) ])(Data_Semigroup.append(Data_Semigroup.semigroupArray)(withPrefix("Sec.")(extra.sector))(Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Monoid_Extra.mwhen(Data_Monoid.monoidArray)(Data_Eq.eq(eqHouseOrBlock)(extra.houseOrBlock)(Block.value))(Data_Semigroup.append(Data_Semigroup.semigroupArray)(withPrefix("Bl.")(extra.block))(Data_Semigroup.append(Data_Semigroup.semigroupArray)(withPrefix("Sc.")(extra.staircase))(Data_Semigroup.append(Data_Semigroup.semigroupArray)(withPrefix("Et.")(extra.floor))(Data_Semigroup.append(Data_Semigroup.semigroupArray)(withPrefix("Ap.")(extra.aptNumber))(withPrefix("Intf.")(extra.interphone)))))))(withPrefix("Reper:")(extra.additionalInfo)))));
};
var formatCountrySpecificAddress = function (country) {
    return function (address) {
        if (Data_Eq.eq(Restaumatic_Countries.eqCountry)(country)(Restaumatic_Countries.RO.value)) {
            return new Data_Maybe.Just(formatRomanianAddress(address));
        };
        if (Data_Boolean.otherwise) {
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Address (line 121, column 1 - line 121, column 75): " + [ country.constructor.name, address.constructor.name ]);
    };
};
var decodeForeignHouseOrBlock = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericHouseOrBlock)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "House";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Block";
        }
    })))
};
var decodeForeignAddressExtra = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericAddressExtra)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "AddressExtra";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "staircase";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "sector";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "interphone";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "houseOrBlock";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeForeignHouseOrBlock))())({
        reflectSymbol: function () {
            return "floor";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "block";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "aptNumber";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "additionalInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
export {
    DeliveryAddress,
    LocatedDeliveryAddress,
    AddressExtra,
    House,
    Block,
    displayHouseOrBlock,
    emptyAddressExtra,
    isPostCodeRequired,
    formatAddressForDisplay,
    formatCountrySpecificAddress,
    newtypeDeliveryAddress,
    showDeliveryAddress,
    eqDeliveryAddress,
    newtypeLocatedDeliveryAddress,
    showLocatedDeliveryAddress,
    eqLocatedDeliveryAddress,
    genericHouseOrBlock,
    eqHouseOrBlock,
    showHouseOrBlock,
    encodeForeignHouseOrBlock,
    decodeForeignHouseOrBlock,
    newtypeAddressExtra,
    genericAddressExtra,
    decodeForeignAddressExtra,
    encodeForeignAddressExtra,
    showAddressExtra,
    eqAddressExtra
};
//# sourceMappingURL=index.js.map
